var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconScreenShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0414 10.5676L13.0541 16.8247C13.0324 18.2079 10.9468 18.1757 10.9418 16.7664L11.0414 10.5676L9.43464 12.1744C9.03463 12.5744 8.44548 12.5636 8.04548 12.1636C7.64547 11.7636 7.63463 11.1744 8.03463 10.7744L11.3414 7.46763C11.4414 7.36763 11.5334 7.30984 11.6414 7.26763C11.7494 7.22542 11.9199 7.19636 12.0491 7.19302C12.1983 7.18916 12.3387 7.23131 12.4414 7.26763C12.5442 7.30395 12.6414 7.36763 12.7414 7.46763L16.0433 10.7695C16.2433 10.9695 16.3536 11.1975 16.3536 11.4975C16.3536 11.7975 16.2414 11.9676 16.0414 12.1676C15.6414 12.5676 15.0433 12.5695 14.6433 12.1695L13.0414 10.5676Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4H20C21.6569 4 23 5.34315 23 7V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V7C1 5.34315 2.34315 4 4 4ZM21 7C21 6.44772 20.5523 6 20 6H4C3.44772 6 3 6.44772 3 7V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V7Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconScreenShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconScreenShare.ba834df236c1741fd0a61ef392cb034e.svg";